/**
 * Created by Mohamed on 4/20/2016.
 */
window.TeamScheduleUserAPI = new function () {
    var self = this;

    var _protected = BaseAPI.call(self);
    _protected.setApiUrl(environmentsConfig.getEnv().host == environmentsConfig.TEAM_SCHEDULE ? publicConfiguration.TSTeamServerBaseURL : publicConfiguration.TeamServerBaseURL);


    /**
     * send activation email to user
     * @param token
     * @param password
     * @returns {deferred.promise|{then, always}}
     */
    self.activate = function (email) {
        var deferred = $q.defer();

        var params = {
            email: email
        };

        _protected.request("activate_user", "POST", params)
            .then(function (res) {
                if (res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.verifyEmail = function (token) {
        var deferred = $q.defer();

        var payload = {
            token: token
        }

        _protected.request("email/verify", "POST", payload)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                console.error(err);
                deferred.reject(err);
            })

        return deferred.promise;
    };

};
